import { gsap } from 'gsap';
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, ScrollToPlugin, SplitText);

gsap.utils.toArray(".background").forEach((section, i) => {
    const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
    gsap.timeline({
        scrollTrigger: {
            trigger: section.parentElement,
            scrub: true,
            invalidateOnRefresh: true
        }
    })
    .fromTo(section, {
        y: -heightDiff
    }, {
        y: 0,
        ease: "none"
    });
});

document.querySelectorAll('.box').forEach(box => {
    box.addEventListener('click', () => {
        const item = box.closest('.item');
        const banner = item.querySelector('.banner');
        const content = item.querySelector('.content');
        let scrollDuration = 1000;
        document.querySelectorAll('.content').forEach(otherContent => {
            if (otherContent !== content && otherContent.classList.contains('active')) {
                gsap.to(otherContent, {
                    opacity: 0,
                    duration: 0.5,
                    height: 0,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        otherContent.classList.remove('active');
                        otherContent.closest('.item').querySelector('.banner').classList.remove('active');
                    }
                });
            }
        });

        if (content.classList.contains('active')) {
            gsap.to(content, {
                opacity: 0,
                height: 0,
                duration: 0.5,
                ease: 'power2.inOut',
                onComplete: () => {
                    content.classList.remove('active');
                    banner.classList.remove('active');
                }
            });
        } else {
            gsap.to(content, {
                opacity: 1,
                height: 'auto',
                duration: 0.5,
                ease: 'power2.inOut',
                onComplete: () => {
                    content.classList.add('active');
                    banner.classList.add('active');
                    if (content.offsetTop > window.innerHeight) {
                        scrollDuration = 2000;
                    }
                    window.scrollTo({
                        top: content.offsetTop - 100,
                        behavior: 'smooth',
                        duration: scrollDuration
                    });
                }
            });
        }
    });
});

$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    // --- SWIPER ---

    var swiper = new Swiper(".wines-swiper-thumb", {
        slidesPerView: 4,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 7,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 7,
                spaceBetween: 90,
            },
            1440: {
                slidesPerView: 7,
                spaceBetween: 90,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        autoHeight: true,
    });
    var swiper2 = new Swiper(".wines-swiper", {
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        thumbs: {
            swiper: swiper,
        },
    });

    // --- BACK TO TOP ---

    var offset = 150,
        offset_opacity = 600,
        scroll_top_duration = 350,
        $back_to_top = $('.back-to-top');

    $(window).scroll(function () {
        ($(this).scrollTop() > offset) ? $back_to_top.addClass('is-visible'): $back_to_top.removeClass('is-visible fade-out');
        if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass('fade-out');
        }
    });
    $back_to_top.on('click', function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0,
        }, scroll_top_duration);
    });


    // --- NAV ---
    
    $(".nav-search").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-search-modal .search-close").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-responsive").removeClass("active");
        $(".burger").removeClass("active")
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-modal .cart-close").click(function () {
        $(".nav-cart-modal").toggleClass("active"); 
        
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-burger, .nav-responsive-overlay").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $(".nav-responsive-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport"); 
    });
    
    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-responsive ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        }
    });
    
    $(".page-single article .gallery br").remove();

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    // --- WORDPRESS FORM CONTROL ---
    
    $(".widget_archive select").addClass("form-control");
    $(".widget_categories select").addClass("form-control");
    $(".woocommerce-account .woocommerce").addClass("row justify-content-between");
    
    $(document.body).trigger('wc_fragment_refresh');

    // $('.form-select').niceSelect();
    

});